export const joinStrings = (textArr: (string | null | undefined)[], seperator: string = " • "): string => {
  return textArr.filter((text) => (text ?? "").trim().length > 0).join(seperator)
}
